import { render } from "./home_two_columns_stretch.vue?vue&type=template&id=6bf5323d"
import script from "./home_two_columns_stretch.vue?vue&type=script&lang=js"
export * from "./home_two_columns_stretch.vue?vue&type=script&lang=js"

import "./home_two_columns_stretch.vue?vue&type=style&index=0&id=6bf5323d&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__